import type { CompletedDegree, DegreePlan } from '@teachur/http-client';

import { useCoursePlan } from './useCoursePlan';

export interface LoadingCourseBuilder {
  status: 'loading';
}

export interface FailedCourseBuilder {
  status: 'error';
  retry: () => void;
}

export interface WizardIncompleteCourseBuilder {
  status: 'wizard-incomplete';
}

export interface ReadyCourseBuilder {
  status: 'ready';
  plans: DegreePlan[];
  completedDegrees: CompletedDegree[];
}

export type CourseBuilderState =
  | LoadingCourseBuilder
  | FailedCourseBuilder
  | WizardIncompleteCourseBuilder
  | ReadyCourseBuilder;

export const useCourseBuilder = (): CourseBuilderState => {
  const { wizardComplete, isLoading, isError, plans, completedDegrees, retry } = useCoursePlan();

  if (isLoading) {
    return { status: 'loading' };
  }
  if (isError) {
    return { status: 'error', retry };
  }
  if (!wizardComplete) {
    return { status: 'wizard-incomplete' };
  }
  return { status: 'ready', plans, completedDegrees };
};
